import React, { useEffect, useMemo, useRef, useState } from 'react'
import styles from './styles/app.module.scss'
import { useLocation, Outlet, useSearchParams } from 'react-router-dom'
import { getRoute } from './router'
import MainLayout from '@/pages/main-layout/main-layout'
import { TOKEN_INVALID } from './event/user'
import { useEvent } from './event'
import { useAppDispatch, useAppSelector } from './store/hooks'
import { logout } from './store/user'
import { getUserAsync, selectIsLoggedIn } from '@/store/user'
import activityApi from './apis/activity'
import { ApplyResponse } from '@/apis/product'
import { Modal } from 'antd-mobile'
import Event from '@/event'
import { APPLY_STATUS_MODAL } from '@/event/constant'
import { TOKEN } from '@/constants/storage'
import { Storage } from '@bihu/common-js'

interface ApplyResponseType extends ApplyResponse{
  productName: string
}

const App: React.FC = () => {
  const location = useLocation()
  const event = useEvent()
  const dispatch = useAppDispatch()
  const [search] = useSearchParams()

  // 是否已登录
  const isLoggedIn = useAppSelector(selectIsLoggedIn)
  let interval = useRef<ReturnType<typeof setInterval>>()
  // 当前页面是否可见
  const [visibilityState, setVisibilityState] = useState<'hidden' | 'visible'>('visible')

  useEffect(() => {

    if (isLoggedIn) {

      if (interval.current) {
        clearInterval(interval.current)
      }

      // 登录后立即上报一次心跳
      if (visibilityState === 'visible') {
        activityApi.health()
      }

      interval.current = setInterval(() => {
        if (visibilityState === 'visible') {
          // 上报用户在线心跳
          activityApi.health()
        }
      // eslint-disable-next-line no-magic-numbers
      }, 5000)
    }

    return () => {
      clearInterval(interval.current)
    }
  }, [isLoggedIn, visibilityState])

  // 监听页面是否可见
  useEffect(() => {
    const visibilitychange = () => {
      setVisibilityState(document.visibilityState)
    }
    document.addEventListener('visibilitychange', visibilitychange)

    return () => {
      document.removeEventListener('visibilitychange', visibilitychange)
    }
  }, [])

  const applyStatusModalCallBack = async(obj:ApplyResponseType) => {

    if (obj.applyStatus === 0) {
      Modal.alert({
        content: '该产品销售火爆，请关注其他商品或更换手机号登录后尝试',
        onConfirm: () => {
          // console.log('Confirmed')
        },
      })
    } else if (obj.applyStatus === 2) {
      const result = await Modal.confirm({
        content: '该手机号已注册，点击确认跳转下载页面',
      })
      if (result) {
        window.location.href = `/inline-page?url=${obj.thirdpartyTargetUrl}${obj.productName ? `&productName=${obj.productName}` : ''}`
      }
    }
  }

  useEffect(() => {

    // token 过期，退出登录
    event.on(TOKEN_INVALID, () => {

      dispatch(logout())
      // 半流程申请页自行展示失效文案，不跳转注册页
      if (window.location.pathname.startsWith('/half/apply')) {
        return
      }
      // 登陆页
      // window.location.href = '/login'
      // token过期的，统一跳转到注册完件页，有adChannelCode就带adChannelCode过去
      const adChannelCode = search.get('adChannelCode')
      window.location.href = `/getQuota${adChannelCode ? `?adChannelCode=${adChannelCode}` : ''}`
    })

    Event.off(APPLY_STATUS_MODAL, applyStatusModalCallBack)
    Event.on(APPLY_STATUS_MODAL, applyStatusModalCallBack)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // 获取用户信息
    const getUserAsyncFn = async() => {
      await dispatch(getUserAsync())
    }

    Storage.get(TOKEN) && isLoggedIn && getUserAsyncFn()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  // 是否需要显示主布局
  const hasMainLayout = useMemo(() => {
    const route = getRoute(location.pathname)
    return route ? route.hasMainLayout : false
  }, [location])


  return <div className={styles.app} id="app">
    {
      hasMainLayout ? <MainLayout><Outlet/></MainLayout> : <Outlet/>
    }
  </div>
}

export default App
